// extracted by mini-css-extract-plugin
export var bodyFont = "on-demand-selector-module--body-font--fd210";
export var close_button = "on-demand-selector-module--close_button--eb70a";
export var on_demand_body_wrapper = "on-demand-selector-module--on_demand_body_wrapper--f161a";
export var on_demand_wrapper = "on-demand-selector-module--on_demand_wrapper--8f28d";
export var titleFont = "on-demand-selector-module--title-font--09843";
export var with_shadow = "on-demand-selector-module--with_shadow--cf8e8";